<template>
    <v-dialog :model-value="modelValue" @update:model-value="$emit('update:modelValue', $event)" max-width="560">
        <v-card v-if="scadenza">
            <v-card-title class="d-flex align-center">
                <v-icon color="blue" class="mr-2">mdi-check-circle</v-icon>
                <div>
                    <div>Scadenza completata</div>
                    <div class="text-caption text-medium-emphasis font-weight-regular">
                        {{ scadenza.mezzoNome }} — {{ scadenza.tipoScadenzaMezzoNome }}
                    </div>
                </div>
                <v-spacer />
                <v-btn icon variant="text" size="small" @click="chiudi">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-title>

            <v-card-text>
                <v-row dense class="mb-1">
                    <v-col cols="6">
                        <div class="text-caption text-medium-emphasis">Data completamento</div>
                        <div class="font-weight-medium">{{ formattaData(scadenza.dataCompletamento) }}</div>
                    </v-col>
                </v-row>

                <template v-if="scadenza.descrizione">
                    <div class="text-caption text-medium-emphasis mt-3">Descrizione pianificata</div>
                    <div class="text-body-2">{{ scadenza.descrizione }}</div>
                </template>

                <template v-if="scadenza.noteCompletamento">
                    <div class="text-caption text-medium-emphasis mt-3">Note di completamento</div>
                    <div class="text-body-2">{{ scadenza.noteCompletamento }}</div>
                </template>

                <template v-if="scadenza.foto && scadenza.foto.length">
                    <div class="text-caption text-medium-emphasis mt-3 mb-1">Foto</div>
                    <v-row dense>
                        <v-col v-for="f in scadenza.foto" :key="f.id" cols="6" sm="4">
                            <v-card variant="outlined" class="rounded-lg pa-2 d-flex align-center">
                                <v-icon size="small" class="mr-1">mdi-image</v-icon>
                                <span class="text-caption text-truncate">{{ f.nomeOriginale }}</span>
                            </v-card>
                        </v-col>
                    </v-row>
                </template>
            </v-card-text>

            <v-card-actions>
                <v-spacer />
                <v-btn variant="text" @click="chiudi">Chiudi</v-btn>
                <v-btn color="primary" variant="text" @click="vaiMezzo">Vai al mezzo</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: "DialogDettaglioScadenzaMezzo",

    props: {
        modelValue: { type: Boolean, default: false },
        scadenzaMezzoId: { type: [Number, String], default: null },
    },
    emits: ["update:modelValue"],

    computed: {
        scadenza() {
            return this.$store.getters["scadenzeMezzo/corrente"];
        },
    },

    watch: {
        modelValue(val) {
            if (val && this.scadenzaMezzoId) {
                this.$store.dispatch("scadenzeMezzo/caricaDettaglio", this.scadenzaMezzoId);
            }
        },
    },

    methods: {
        formattaData(iso) {
            if (!iso) return "—";
            return new Date(iso).toLocaleDateString("it-IT", {
                day: "numeric", month: "long", year: "numeric",
            });
        },

        chiudi() {
            this.$emit("update:modelValue", false);
        },

        vaiMezzo() {
            if (this.scadenza) {
                this.$router.push("/mezzi/" + this.scadenza.mezzoId);
            }
            this.chiudi();
        },
    },
};
</script>
